import { type IGrantedLocationView } from '@shared/services';

export const formatGrantedLocationAddress = ({
  address,
  address2,
  city,
  state,
  zipCode,
  country,
}: IGrantedLocationView): string => {
  return [address, address2, city, state, zipCode, country]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(', ');
};
